import { useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { useStoreCart } from '../../context/StoreCartContext';
import { t } from '../../i18n/translations';

function CartIcon() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="9" cy="21" r="1" />
      <circle cx="20" cy="21" r="1" />
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
    </svg>
  );
}

export default function StoreNavCartButton({ className = 'daiv-nav-cart-btn' }) {
  const { lang } = useLanguage();
  const { pathname } = useLocation();
  const { itemCount, openDrawer } = useStoreCart();

  const onStoreRoute = pathname === '/store' || pathname.startsWith('/store/');
  if (!onStoreRoute && itemCount <= 0) return null;

  return (
    <button
      type="button"
      className={className}
      onClick={openDrawer}
      aria-label={t('store.cartButton', lang)}
    >
      <CartIcon />
      {itemCount > 0 && <span className="daiv-nav-cart-btn__count">{itemCount}</span>}
    </button>
  );
}
